var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendGateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6428 0L13.9906 2.69933L3.84224 7.76695V7.84264V14H0.00927734V6.74199C0.00927734 5.68347 0.867305 4.82551 1.92576 4.82551C2.19149 4.82551 2.44464 4.87971 2.67474 4.97749L12.6428 0ZM3.65271 5.22901L3.6656 5.93735C3.57393 5.73943 3.44949 5.55977 3.29928 5.40544L3.65271 5.22901ZM7.3069 3.40413L4.61522 4.74835L4.62509 6.63597L7.34113 5.27967L7.3069 3.40413ZM8.26941 2.92347L8.27935 4.81138L10.9953 3.45508L10.9611 1.57954L8.26941 2.92347ZM13.1028 2.40274L11.9335 2.98649L11.9236 1.09888L12.3463 0.887701L13.1028 2.40274ZM0.760466 6.408H3.01411V8.2859H0.760466V6.408Z",
    fill: "#605E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5264 8.39837C13.2042 10.0058 12.9754 11.2689 10.5262 13.9279C10.5262 13.9279 12.257 13.4681 12.6462 13.9279C13.0355 14.3878 15.2092 9.78705 11.9396 7.22111L12.9778 6.322L9.46711 5.68982L9.35871 9.33795L10.5264 8.39837Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendGateIcon);
export default __webpack_public_path__ + "static/media/VendGateIcon.4906a60aea31a28e24b0914f23e600c4.svg";
export { ForwardRef as ReactComponent };